<template>
  <div class="page-wrapper storybook-cnc-tab-menu">
    <StorybookTemplate title="CncTabMenu" pathComponent="/shared/elements/global/v1/CncTabMenu.vue" :pathFigma="pathFigma" :propList="propList" :form.sync="form">
      <CncTabMenu v-bind="form" />
      <router-view></router-view>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../../components/StorybookTemplate.vue'),
  },
  data () {
    return {
      pathFigma: 'https://www.figma.com/design/QGmzH850ARJRAeL8BuBAer/%5BSpace%5D-Web-components?node-id=1655-76825&p=f&t=4PeVUDh9OhjQtwzf-0',
      propList: [
        { name: 'menus', type: 'array', param: 'menus', default: [] },
        { name: 'hasBorder', type: 'boolean', param: 'hasBorder', default: 'true' },
        { name: 'hasBg', type: 'boolean', param: 'hasBg', default: 'true' },
        { name: 'hasDividerLine', type: 'boolean', param: 'hasDividerLine', default: 'true' },
        { name: 'hasArrow', type: 'boolean', param: 'hasArrow', default: 'true' },
        { name: 'ignoreRouter', type: 'boolean', param: 'ignoreRouter', default: 'false' },
        { name: 'shouldCheckQuery', type: 'boolean', param: 'shouldCheckQuery', default: 'false' },
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'medium',
          option: [
            { label: 'small', name: 'Small' },
            { label: 'medium', name: 'Medium' },
            { label: 'large', name: 'Large' }
          ]
        },
      ],
      form: {
        menus: [
          { id: 1, name: 'Example tab menu main', href: '/components/conicle-space-and-coniverse/components/tab-menu/', icon: 'ico_compass' },
          { id: 2, name: 'Example tab menu 1 case is query', href: '/components/conicle-space-and-coniverse/components/tab-menu/tab1', query: { is_coniclex: true }, icon: 'ico_compass' },
          { id: 3, name: 'Example tab menu 2 case is disabled', href: '/components/conicle-space-and-coniverse/components/tab-menu/tab2', icon: 'ico_compass', disabled: true },
          { id: 4, name: 'Example tab menu 3 case is active selected', href: '/components/conicle-space-and-coniverse/components/tab-menu/tab3', icon: 'ico_compass', active: true },
          { id: 5, name: 'Example tab menu 4 case is long name design system test', href: '/components/conicle-space-and-coniverse/components/tab-menu/tab4', icon: 'ico_compass' },
          // {
          //   id: 5,
          //   name: 'more',
          //   href: '/components/conicle-space-and-coniverse/components/tab-menu/tab5',
          //   icon: 'ico_compass',
          //   dropdown: true,
          //   dropdownValue: null,
          //   options: [
          //     { id: 1, label: 'Live', value: 1 },
          //     { id: 2, label: 'Test', value: 2 },
          //     { id: 3, label: 'Activity', value: 3 }
          //   ]
          // }
        ],
        hasBorder: true,
        hasBg: true,
        hasDividerLine: true,
        hasArrow: true,
        ignoreRouter: false,
        shouldCheckQuery: false,
        size: 'medium'
      }
    }
  }
}
</script>
